<template>
  <div class="index">
    <van-overlay :show="!overlayType">
      <div class="wrapper">
        <van-loading size="24px" vertical color="#0094ff">加载中...</van-loading>
      </div>
    </van-overlay>
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div v-if="car.length !=0">
      <div class="carList" v-for="(item,key) in car" :key="key" @click="sheetShow(item,key)">
        <div class="imgBox"><img src="../../../static/images/icon_washcard.png" alt=""></div>
        <div class="content">
          <div class="num">{{item.carNum}}</div>
        </div>
        <div class="type" :style="item.carState==1?'color: #76cabc;':'color:red;'">{{carStareArr[item.carState]}}</div>
      </div>
    </div>
    <div v-else>
      <div style="margin-top:2rem;">
        您目前没有门卡
      </div>
    </div>

    <!-- 绑卡 -->
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @cancel="show = false"
      @select="oncheck"
    />
  </div>
</template>

<script>
  import {Dialog} from 'vant'
  import wx from 'weixin-js-sdk'

  function getUrlKey (name) {//获取url 参数
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  function getCodeApi (state) {//获取code
    let urlNow = encodeURIComponent(window.location.href)
    let scope = 'snsapi_base'    //snsapi_userinfo   //静默授权 用户无感知
    let appid = 'wxd104040ca687111a'
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    window.location.replace(url)
  }

  export default {
    data () {
      return {
        overlayType: false,
        openId: '',
        title: '我的门卡',
        // 无 我的卡片  ， 1 补换卡 ,2 退卡
        type: 0,
        carStareArr: ['已失效', '正常'],
        car: [
          // {carNum:9999,carState:1},

        ],
        show: false,
        show2: false,
        actions: [{name: '提交补卡申请'}, {name: '提交换卡申请'}, {name: '登记新卡号'},],
        pinkList: {}
        // actions2: [],
      }
    },
    created () {
      if (this.$route.query.type) {
        this.type = this.$route.query.type
        if (this.$route.query.type == 1) {
          this.title = '补卡换卡'
        } else if (this.$route.query.type == 2) {
          this.title = '退押金'
          this.actions = [{name: '提交退卡申请'}, {name: '提交退押金'}]
        }
      }

    },
    mounted () {
      let code = getUrlKey('code')//获取url参数code
      if (code) { //拿到code， code传递给后台接口换取opend
        this.code = code

        let currentUrl = location.href.split('#')[0]

        let data = new FormData()
        data.append('code', this.code)
        data.append('url', currentUrl)
        this.$axios.post('/api/smartcard/getOpenIdByCode', data).then(res => {
          if (res.data.success) {
            this.openId = res.data.userObject.openId
            let dd = res.data.userObject
            console.log(dd)
            this.myLockcards()
          } else {
            this.$toast.fail('加载openId失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          console.log(error)
          this.$toast.fail('加载openId失败!')
        })
      } else {
        getCodeApi('qksmartcardfill2020')

      }
    },
    methods: {
      myLockcards () {
        let data = {
          openId: this.openId
        }
        this.$axios.post('/lockapi/smartlock/my-lockcards', data).then(res => {
          if (res.data.success) {
            this.overlayType = true
            this.car = res.data.userObject
          } else {
            this.$toast.fail('加载卡包失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          console.log(error)
          this.$toast.fail('加载卡包失败!')
        })

        let currentUrl = location.href.split('#')[0]

        let dd = new FormData()
        dd.append('openId', this.openId)
        dd.append('url', currentUrl)
        this.$axios.post('/lockapi/smartlock/get-wxconfig-data', dd).then(res => {
          if (res.data.success) {
            let dd = res.data.userObject
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: dd.appId, // 必填，公众号的唯一标识
              timestamp: dd.timestamp, // 必填，生成签名的时间戳
              nonceStr: dd.nonceStr, // 必填，生成签名的随机串
              signature: dd.signature, // 必填，签名，见附录1
              jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })

          } else {
            this.$toast.fail('wxconfig失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          console.log(error)
          this.$toast.fail('wxconfig失败!')
        })
      },

      //   动作面板选择
      oncheck (item) {
        let _that = this
        console.log(item)
        if (item.name == '提交补卡申请') {
          Dialog.confirm({
            title: '提交补卡申请',
            message: '是否要提交卡号为' + this.pinkList.carNum + '的补卡申请,需支付工本费' + this.pinkList.feeMoney + '元',
            confirmButtonText: '提交并支付',
            confirmButtonColor: 'red'
          })
            .then(() => {

              let data = {
                openId: this.openId,
                cardNumber: this.pinkList.carNum,
                bizType: 1,
              }
              this.$axios.post('/lockapi/smartlock/submit-request-bill', data).then(res => {
                if (res.data.success) {
                  let data = res.data.userObject
                  if (data.needPay) {
                    wx.chooseWXPay({
                      timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                      nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                      package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                      signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                      paySign: data.paySign, // 支付签名
                      success: function (res) {
                        _that.$toast.success('提交成功!')
                      },
                      fail: function (res) {
                      }
                    })
                  } else {
                    _that.$toast.success('提交成功!')
                  }
                } else {
                  this.$toast.fail('提交失败,原因：' + res.data.msg + '!')
                }
              }).catch(error => {
                this.$toast.fail('提交失败!')
              })
              // on confirm
            })
            .catch(() => {
              // on cancel
            })
        } else if (item.name == '提交换卡申请') {
          Dialog.confirm({
            title: '提交换卡申请',
            message: '是否要提交卡号为' + this.pinkList.carNum + '的换卡申请',
            confirmButtonText: '确认换卡申请',
            confirmButtonColor: 'red'
          })
            .then(() => {
              let data = {
                openId: this.openId,
                cardNumber: this.pinkList.carNum,
                bizType: 2,
              }
              this.$axios.post('/lockapi/smartlock/submit-request-bill', data).then(res => {
                if (res.data.success) {
                  this.$toast.success('提交成功!')
                } else {
                  this.$toast.fail('提交失败,原因：' + res.data.msg + '!')
                }
              }).catch(error => {
                this.$toast.fail('提交失败!')
              })
              // on confirm
            })
            .catch(() => {
              // on cancel
            })
        } else if (item.name == '登记新卡号') {
          let data = {
            openId: this.openId,
            cardNumber: this.pinkList.carNum,
          }
          this.$axios.post('/lockapi/smartlock/check-input-newcardnumber', data).then(res => {
            if (res.data.success) {
              this.$router.push({
                path: '/intelligentLock/carchangeApplyfor', query: {
                  openId: this.openId,
                  cardNumber: this.pinkList.carNum,
                }
              })
            } else {
              this.$toast.fail('不能进行操作，原因：' + res.data.msg + '!')
            }
          }).catch(error => {
            this.$toast.fail('不能进行该操作!')
          })

        } else if (item.name == '提交退卡申请') {
          Dialog.confirm({
            title: '提交退卡申请',
            message: '是否要提交卡号为' + this.pinkList.carNum + '的退卡申请',
            confirmButtonText: '确认退卡申请',
            confirmButtonColor: 'red'
          })
            .then(() => {
              let data = {
                openId: this.openId,
                cardNumber: this.pinkList.carNum,
                bizType: 3,
              }
              this.$axios.post('/lockapi/smartlock/submit-request-bill', data).then(res => {
                if (res.data.success) {
                  this.$toast.success('提交成功!')
                } else {
                  this.$toast.fail('提交失败,原因：' + res.data.msg + '!')
                }
              }).catch(error => {
                this.$toast.fail('提交失败!')
              })
              // on confirm
            })
            .catch(() => {
              // on cancel
            })
        } else if (item.name == '提交退押金') {

          let data = {
            openId: this.openId,
            cardNumber: this.pinkList.carNum,
          }
          this.$axios.post('/lockapi/smartlock/check-return-deposit', data).then(res => {
            if (res.data.success) {
              this.$router.push({
                path: '/intelligentLock/caroutApplyfor', query: {
                  openId: this.openId,
                  cardNumber: this.pinkList.carNum,
                }
              })
            } else {
              this.$toast.fail('不能进行操作，原因：' + res.data.msg + '!')
            }
          }).catch(error => {
            this.$toast.fail('不能进行该操作!')
          })

        }
      },
      // 更加不同的类型显示不同的动作面板
      sheetShow (item, key) {
        if (this.type == 0) {
          return
        }
        // 把选中的卡号对象抛出来
        this.pinkList = item
        this.show = true
      },
      onClickLeft () {
        // this.$router.push('/intelligentLock/portal')
        location.href = '/#/intelligentLock/portal'
      }
    },
  }
</script>
<style lang="less" scoped>
  .index {
    width: 100%;
    height: 100%;

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .carList {
      height: 4rem;
      margin: 1rem 0.5rem;
      border-radius: 0.5rem;
      display: flex;
      justify-content: left;
      box-shadow: 0px 0px 10px #bbb;
      background-color: #fff;

      .imgBox {
        width: 4rem;

        img {
          width: 2.8rem;
          height: 2.8rem;
          margin: 0.5rem 0.5rem;
        }
      }

      .content {
        width: 7rem;
        margin-top: 0.8rem;
        text-align: left;
        margin-left: 0.5rem;
        padding-top: 0.8rem;

        .num {
          line-height: 1rem;
          font-size: 0.8rem;
        }

      }

      .type {
        line-height: 4rem;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/intelligentLock/lockcard.vue